import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { schoolInfoCrudStateConfig } from "../consts";
import SchoolInfo from "./SchoolInfo";

export type SchoolInfoMeta = CrudBuilderState | Map<any, any>;

export const schoolInfoMetaInitialState = makeCrudBuilderInitialState(
  schoolInfoCrudStateConfig
);

export type SchoolInfoStateType = {
  schoolInfo: SchoolInfo | null;
  meta: SchoolInfoMeta;
};

const defaultSchoolInfoStateSlice: SchoolInfoStateType = {
  schoolInfo: null,
  meta: schoolInfoMetaInitialState
};

export default class SchoolInfoState extends Record<SchoolInfoStateType>(
  defaultSchoolInfoStateSlice
) {}
